import {useKeycloakFunctions} from "./useKeycloakFunctions";
import {bookingAPI} from "../common/api/bookingAPI";
import {API_PREARRIVAL} from "../common/api/apiConstants";
import {useState} from "react";

export const useManageReservations = () => {
    const {initialized, authenticated} = useKeycloakFunctions();

    const [isPreArrivalEmailSent, setIsPreArrivalEmailSent] = useState(false);
    const [loadingSendPreArrivalEmail, setLoadingSendPreArrivalEmail] = useState(false);
    const [errorSendPreArrivalEmail, setErrorSendPreArrivalEmail] = useState(false);

    const [isPreArrivalEmailRetried, setPreArrivalEmailRetried] = useState(false);
    const [loadingRetryPreArrivalEmail, setLoadingRetryPreArrivalEmail] = useState(false);
    const [errorRetryPreArrivalEmail, setErrorRetryPreArrivalEmail] = useState(false);

    const sendPreArrivalEmail = (payload) => {
        if (initialized && authenticated) {
            setLoadingSendPreArrivalEmail(true);
            setIsPreArrivalEmailSent(false);
            setErrorSendPreArrivalEmail(null);
            bookingAPI
                .post(API_PREARRIVAL + "/emails/test", payload)
                .then(() => {
                    setIsPreArrivalEmailSent(true);
                })
                .catch(err => {
                    setErrorSendPreArrivalEmail(err?.response?.data?.detail?.msg);
                })
                .finally(() => {
                    setLoadingSendPreArrivalEmail(false);
                });

        }
    };

    const retryPreArrivalEmail = (payload) => {
        if (initialized && authenticated) {
            setLoadingRetryPreArrivalEmail(true);
            setPreArrivalEmailRetried(false);
            setErrorRetryPreArrivalEmail(null);
            bookingAPI
                .post(API_PREARRIVAL + "/emails/retry", payload)
                .then(() => {
                    setPreArrivalEmailRetried(true);
                })
                .catch(err => {
                    setErrorRetryPreArrivalEmail(err?.response?.data?.detail?.msg);
                })
                .finally(() => {
                    setLoadingRetryPreArrivalEmail(false);
                });
        }
    };

    return {
        sendPreArrivalEmail,
        loadingSendPreArrivalEmail,
        isPreArrivalEmailSent,
        errorSendPreArrivalEmail,

        retryPreArrivalEmail,
        loadingRetryPreArrivalEmail,
        isPreArrivalEmailRetried,
        errorRetryPreArrivalEmail
    };
};
